import React, { Component } from "react";
import { connect } from "react-redux";
import { api } from "../../_services";
import { FormGroup, ControlLabel } from "react-bootstrap";
import AsyncSelect from "react-select/lib/Async";
import "react-select/dist/react-select.css";
import "./index.css";

class UserDropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      defaultUser: "",
      selectedUser: undefined
    };
  }

  componentDidMount() {
    this.getAllUsers(this.state.defaultUser);
  }

  getAllUsers = input => {
    const noteId = this.props.noteID;
    const url = "/api/v1/users/";
    const params = {
      query: input,
      can_be_assigned_to_note: noteId
    };
    const errorMsg = "Unable to retrieve users list.";
    return api
      .getFetch(url, params, this.props.user.token, errorMsg)
      .then(json => {
        return { options: json.results };
      });
  };

  filterUser = () => {
    // All filtering is done by the backend
    return true;
  };

  handleChange = selectedOption => {
    this.setState({ selectedUser: selectedOption });
    if (selectedOption) {
      this.props.change(selectedOption);
    }
  };

  render = () => {
    return (
      <div className="user-dropdown">
        <FormGroup controlId="formControlsSelect">
          <ControlLabel>User</ControlLabel>
          <AsyncSelect
            name="form-field-name"
            value={this.state.selectedUser}
            onChange={this.handleChange}
            valueKey="id"
            labelKey="display_name"
            loadOptions={this.getAllUsers}
            filterOption={this.filterUser}
          />
        </FormGroup>
      </div>
    );
  };
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user
  };
}

export default connect(mapStateToProps)(UserDropdown);



// WEBPACK FOOTER //
// ./src/_components/UserDropdown/index.js